module.exports = function(input) {
  return input.toString().replace(/'/g, "\\'")
}
